import { render, staticRenderFns } from "./exhibitionEdit.vue?vue&type=template&id=27f4d3cd&scoped=true&"
import script from "./exhibitionEdit.vue?vue&type=script&lang=js&"
export * from "./exhibitionEdit.vue?vue&type=script&lang=js&"
import style0 from "./exhibitionEdit.vue?vue&type=style&index=0&id=27f4d3cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f4d3cd",
  null
  
)

export default component.exports